import DOMPurify from "dompurify";
export function getSanitizedHtml(data, defaultValue){
    const sanitized = DOMPurify.sanitize(data);
    return {
        __html: sanitized === "" ? defaultValue : sanitized
    }
}